module.exports = __webpack_public_path__ + "img/social_instagram.4895b91.svg";